import { render, staticRenderFns } from "./AlternativeDateRangePicker.vue?vue&type=template&id=1800c0fc"
import script from "./AlternativeDateRangePicker.vue?vue&type=script&lang=js"
export * from "./AlternativeDateRangePicker.vue?vue&type=script&lang=js"
import style0 from "./AlternativeDateRangePicker.vue?vue&type=style&index=0&id=1800c0fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports